<template>
  <div class="accHistory">
    <div class="header">
      <div class="left">
        咨询记录
        <span>
          （最近50条）
        </span>
      </div>
      <div class="right">
        <el-input placeholder="请输入关键词进行搜索" v-model="search" class="searchInput">
          <i slot="suffix" class="el-icon-search searchIcon"></i>
        </el-input>
      </div>

    </div>
    <div class="list" v-if="totalCount !== 0">
      <history-item  v-for="(item,index) in search? searchList(search,historyList):searchList(search,historyList).slice((currentPage-1)*PageSize , currentPage*PageSize)" :key="index"
                     :product="item" del-btn info-btn :del-click="delHistory" @reload="getHistoryList"></history-item>
      <div class="pages" v-if="!search">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="PageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount">
        </common-pagination>
      </div>
    </div>
    <div class="empty" v-else>
      <empty-state
        title="暂无咨询记录"
        description="咨询过的商品会展示在这里"
        icon="el-icon-chat-dot-round"
        :icon-size="52">
      </empty-state>
    </div>

    <!--  删除记录确认框  -->
    <el-dialog
      :visible.sync="delBtnConfrim"
      custom-class="delBtnConfrim"
      :show-close="false"
      width="358px"
      top="35vh"
      center>
      <div id="delBtnConfrim">
        <div class="title">提示</div>
        <div class="text">
          删除记录后将无法恢复<br/>
          是否确认删除？
        </div>
        <div class="btn" @click="historyCusDel">确认删除</div>
        <img class="close" src="../../../assets/image/AccountDeal/close.png" alt="" @click="delBtnConfrim = false">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {apiHistoryCusList,apiHistoryCusDel} from "@/request/API";
import historyItem from "@/views/PersonalCenter/History/historyItem";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: 'accHistory',
  props: {
  },
  components: {
    historyItem,
    CommonPagination,
    EmptyState
  },
  data () {
    return {
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:5,
      // 浏览历史列表
      historyList:[],
      //搜索关键字
      search:'',
      //删除记录确认框
      delBtnConfrim:false,
      //选中要删除的记录id
      selectId:''
    }
  },
  methods: {
    /**
     * 分页监听事件
     * @param val 当前页码
     */
    handleCurrentChange(val) {
      document.body.scrollTop = document.documentElement.scrollTop = 157;
    },
    /**
     * 获取历史浏览列表
     */
    getHistoryList(){
      apiHistoryCusList({
      }).then(res=>{
        this.totalCount = res.data.length
        this.historyList = res.data
      })
    },

    /**
     * 步骤一 搜索游戏名称
     * @param indexKey 关键词
     * @param list 数组
     */
    searchList(indexKey, list) {
      if (indexKey) {
        var reg = new RegExp(indexKey, 'ig')
        return list.filter(function (e) {
          //匹配所有字段
          return Object.keys(e).some(function (key) {
            if (['game_alias', 'game_name', 'name'].includes(key) && typeof e[key] == 'string') {
              return e[key].match(reg);
            }
            return false
          })
          this.$forceUpdate()
        })
      }
      return list;
    },

    /**
     * 删除记录
     */
    delHistory(id){
      this.selectId = id
      this.delBtnConfrim = true
    },

    historyCusDel(id){
      apiHistoryCusDel({
        id:this.selectId
      }).then(res=>{
        this.$message({
          type:"success",
          center:true,
          message:"删除成功"
        })
        this.delBtnConfrim = false
        this.getHistoryList()
      })
    }
  },
  mounted () {
    this.getHistoryList()
  },
  watch: {

  },
  computed: {

  }
}
</script>


<style lang="less">
.delBtnConfrim{
  border-radius: 4px;
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-dialog__header , .el-dialog__body{
    padding: 0 !important;
  }

  #delBtnConfrim{
    position: relative;
    padding: 26px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title{
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 600;
      color: var(--text-main, #111827);
    }

    .text{
      margin: 22px 0;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      text-align: center;
      line-height: 24px;
    }

    .btn{
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: CENTER;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      border-radius: 4px;
      cursor: pointer;
      box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
      transition: background .2s ease, box-shadow .2s ease;
    }

    .btn:hover{
      background: var(--primary-hover, #E84A12);
      box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
    }

    .close{
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
}
</style>

<style scoped lang="less">
.accHistory{
  min-height: 100%;
  padding: 20px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .header{
    min-height: 72px;
    padding: 0 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .left{
      position: relative;
      min-height: 34px;
      padding-left: 14px;
      display: flex;
      align-items: center;
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 28px;

      &:before{
        content: '';
        position: absolute;
        left: 0;
        top: 7px;
        width: 4px;
        height: 20px;
        border-radius: 2px;
        background: var(--primary, #FF5A1F);
      }

      span{
        margin-left: 4px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
      }
    }

    .right{
      flex-shrink: 0;

      .searchInput{
        /deep/.el-input__inner{
          width: 320px;
          height: 40px;
          background: #ffffff;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          padding: 0 48px 0 16px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Light;
          font-weight: 400;
          color: var(--text-main, #111827);
          transition: border-color .2s ease, box-shadow .2s ease;
        }

        /deep/.el-input__inner:focus{
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }

        /deep/.el-input__inner::-webkit-input-placeholder{
          color: var(--text-muted, #9AA0AC);
        }

        /deep/.el-input__suffix{
          display: flex;
          align-items: center;
          right: 16px;
        }

        .searchIcon{
          font-size: 18px;
          line-height: 1;
          color: var(--text-main, #1A1D24);
          opacity: .82;
          transition: opacity .2s ease, color .2s ease;
        }

        /deep/.el-input__inner:focus + .el-input__suffix .searchIcon,
        .searchIcon:hover{
          opacity: 1;
        }
      }

    }
  }

  .list{
    min-height: 560px;
    margin-top: 0;
    padding: 0 0 24px;
    overflow: hidden;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;

    .pages{
      min-height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .empty{
    width: 100%;
    min-height: 560px;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
  }
}

</style>
